import { SaveSearch16 } from '@cian/ui-kit/prev/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { Utility } from '../../components/Utility';
import { IApplicationState } from '../../types/redux';

export const UtilitySavedSearchesContainer: React.FC = () => {
  const savedSearchesLink = useSelector<IApplicationState, string | null>(state => state.servicesLinks.savedSearches);
  const savedSearchesCount = useSelector<IApplicationState, number>(state => state.savedSearches.count);

  if (!savedSearchesLink) {
    return null;
  }

  return (
    <Utility
      title="Сохранённые поиски"
      unread={Boolean(savedSearchesCount)}
      icon={SaveSearch16}
      href={savedSearchesLink}
    />
  );
};
